import { StaticImage } from "gatsby-plugin-image";
import React, { useState } from "react";
import styled from "styled-components";
import { Button } from "../Button";
import ApplicationsCard from "./ApplicationsCard";
import ApplicationsList from "./ApplicationsList";
import TeamsList from "./TeamsList";
import {
  FaArrowAltCircleDown,
  FaArrowAltCircleUp,
  FaArrowRight,
  FaRegArrowAltCircleRight,
} from "react-icons/fa";
import { RiTeamFill } from "react-icons/ri";

import { IoIosArrowDown, IoIosArrowUp } from "react-icons/Io";

import { BsArrowReturnRight } from "react-icons/Bs";
import BreadCrumbs from "../BreadCrumbs";

const Header = () => {
  const text =
    "Payroll management Grant writing (if applicable) Managing team roles and execution Orientation of team members HR management (with team members's help creating applications and hiring contracts and criteria)";

  const buttonStateChange = () => {
    setPositionDuties(!positionDuties);
  };

  const [positionDuties, setPositionDuties] = useState(false);

  const jobsArray = [
    "Payroll management",
    "Grant writing (if applicable)",
    "Managing team roles and execution",
    "Orientation of team members",
    "HR management (with team members’s help creating applications and hiring contracts and criteria)",
  ];

  const learningOutcomes = [
    "Team management skills",
    "Communication skills",
    "Filmmaking skills",
    "Learning to tell a story effectively using digital media",
    "Creating a narrative with purpose",
    "Administrative and organizational skills",
  ];

  return (
    <>
      <BreadCrumbs />
      <TextContainer>
        {/* <StaticImage
          src="../../images/ART/bw-greek-statue-image-torn-paper-style-remixed-media.jpg"
          placeholder="blurred"
          layout="constrained"
          width={900}
          height={380}
          style={{
            border: "solid black 10px",
            marginTop: "1px",
          }}
        /> */}
        {/* <Title>The Dream</Title>
        <Subtitle>
          Do you want to be part of a dream to strengthen Muslim youth skills in
          Canada hence building a stronger Muslim community? Can you envision
          yourself being part of that and contributing to this dream? All MY
          Voice roles, no matter how large or small, train you to work in a
          corporate setting, do jobs where you make mistakes and are coached on
          how to get them done. As a MY Voice youth, you are in charge and also
          under someone's charge. This is your platform - so take control and
          build your future!
        </Subtitle> */}

        <Title>Teams</Title>
        <Subtitle>
          MY Voice is an organization that encourages creative ways to express
          yourself and come up with ideas and solutions. Each team has a project
          you will complete in that year. Each team has a list of roles that
          contribute to the completion of the Project. Learning outcomes stem
          from your role individually and also collectively as a team. Some
          teams are Support teams for the Project teams. These are marked with a
          <SupportIcon /> below.
        </Subtitle>
        <Divider></Divider>

        <TeamsList />

        {/* <PositionTitle>Team: </PositionTitle>
        <PositionTeam>Event Planning</PositionTeam>

        <PositionColumns>
          <Column>
            <PositionTitle>Learning Outcomes:</PositionTitle>

            <ul>
              {learningOutcomes.map((item) => (
                <PositionLearningOutcomes>
                  <BsArrowReturnRight /> {item}
                </PositionLearningOutcomes>
              ))}
            </ul>
          </Column>
          <Column>
            <PositionTitle>Projects: </PositionTitle>
            <PositionLearningOutcomes>
              App: Publish a public and launchable version of the app and
              enhance it
            </PositionLearningOutcomes>
            <PositionLearningOutcomes>
              Web: Enhance current website design and make digital magazine
              website
            </PositionLearningOutcomes>
            <PositionTitle>Prerequisites: </PositionTitle>
            <PositionLearningOutcomes>
              - For web, no coding experience is required, however some basic
              knowledge of HTML & CSS and/or experience with Wordpress would be
              preferred. - For app, prior coding experience in any algorithmic
              language (Python, Java, C++, Dart, etc.) and/or widget-based
              toolkit (React.js, Flutter) would be nice, however once again, it
              is not a requirement as they can always learn on the job.
            </PositionLearningOutcomes>
          </Column>
        </PositionColumns>

        <PositionTitle>Roles:</PositionTitle>

        <PositionsContainer>
          <CardsContainer>
            <Card>
              <CardContent>
                <CardTitle>Team Lead</CardTitle>

                <CardP>
                  Payroll management Grant writing (if applicable) Managing team
                  roles and execution Orientation of team members HR management
                  (with team members's help creating applications and hiring
                  contracts and criteria)
                </CardP>
                <Button>
                  Apply <FaArrowRight />
                </Button>
              </CardContent>
              {jobsArray.map((items) => (
                <CardP> - {items}</CardP>
              ))}
            </Card>

            <Card>
              <CardContent>
                <CardTitle>Web Coordinator (x1-2)</CardTitle>
                <Button>
                  Apply <FaArrowRight />
                </Button>
              </CardContent>

              {jobsArray.map((items) => (
                <CardP> - {items}</CardP>
              ))}
            </Card>
            <Card>
              <CardTitle>App Developer (x2)</CardTitle>
              <CardP>
                Payroll management Grant writing (if applicable) Managing team
                roles and execution Orientation of team members HR management
                (with team members's help creating applications and hiring
                contracts and criteria)
              </CardP>
            </Card>
            <Card>
              <CardTitle>UI Designers (x3)</CardTitle>
              <CardP>
                Payroll management Grant writing (if applicable) Managing team
                roles and execution Orientation of team members HR management
                (with team members's help creating applications and hiring
                contracts and criteria)
              </CardP>
            </Card>
            <Card>
              <CardTitle>Copy & Content Writing</CardTitle>
              <CardP>
                Payroll management Grant writing (if applicable) Managing team
                roles and execution Orientation of team members HR management
                (with team members's help creating applications and hiring
                contracts and criteria)
              </CardP>
            </Card>
            <Card>
              <CardTitle>Business & Marketing</CardTitle>
              <CardP>
                Payroll management Grant writing (if applicable) Managing team
                roles and execution Orientation of team members HR management
                (with team members's help creating applications and hiring
                contracts and criteria)
              </CardP>
            </Card>
          </CardsContainer>
        </PositionsContainer> */}
      </TextContainer>
    </>
  );
};
const TextContainer = styled.div`
  padding: 1rem calc((100vh - 175px) / 2);

  @media screen and (max-width: 768px) {
    padding: 0rem 1rem;
  }
`;
const Title = styled.h1`
  font-size: clamp(4.3rem, 3vw, 2rem);
`;

const Divider = styled.div`
  height: 1px;
  background-color: gray;

  margin: 1rem auto;
`;

const Subtitle = styled.p`
  font-size: 1rem;
  margin-bottom: 1.5rem;
`;

const SupportIcon = styled(RiTeamFill)`
  display: inline;
  color: orange;
  padding-bottom: 2px;
  font-size: 1.5rem;
`;

const PositionsContainer = styled.div`
  margin-bottom: 3rem;
`;

const CardTitle = styled.div`
  font-size: clamp(4.5rem, 3vw, 2rem);
  color: gray;
`;
const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: grey;
  overflow: scroll;
  height: 50vh;

  border-top: 1px black solid;
  border-bottom: 1px black solid;


  &::-webkit-scrollbar {

    
    display: none;
`;
const Card = styled.div`
  background-color: #fff;
  width: 95%;
  margin: auto;
  border-bottom: 1px black solid;
  display: flex;
  flex-direction: column;
  padding-top: 10px;
`;
const CardP = styled.p`
  margin-bottom: 3px;
  margin-left: 2rem;
  display: flex;
  align-items: center;
`;

const CardContent = styled.div`
  display: flex;
  justify-content: space-between;
  min-height: 12vh;
  align-items: center;
  padding: 0rem 1rem;
`;

const CardReadMoreButton = styled.div`
  text-decoration: none;
  border: none;
  background-color: orange;
  color: white;
  border: dark-gray 1px solid;
  padding: 10px 5px;
  font-weight: bold;
  cursor: pointer;
  min-height: 1vh;
  transition: all 0.2s ease-in-out;
  &:hover {
    background-color: #00d3ca;
  }
`;

const PositionTitle = styled.div`
  font-size: 2em;
  color: #e2a000;
  margin-top: 1rem;
`;

const PositionTeam = styled.div`
  font-size: 4em;
`;

const PositionLearningOutcomes = styled.p`
  font-size: 1rem;
  font-weight: bold;
  line-height: 2rem;
  display: flex;
  align-items: center;

  columns: 2 auto;
  margin-top: 1rem;
`;

const PositionColumns = styled.div`
  display: grid;
  grid-template-columns: 500px auto;
  grid-gap: 10px;
  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;

const Column = styled.div``;

export default Header;
